import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertHealthScore from "./upsert";
import useCalculatedMetrics from "./use-calculated-metrics";
import usePageChange from "@hooks/use-page-change";
const CalculatedMetrics = () => {
    const {
        data: { calculatedMetrics = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        modalConfig,
        handleModalConfig,
        getHealthScores
    } = useCalculatedMetrics();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Calculated Metrics"
                breadcrumbItems={{
                    items: [
                        {
                            title : "Calculated Metrics",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: calculatedMetrics,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        testId="add-metrics"
                        onClick={() => handleModalConfig()}
                        subject="calculated-metrics"
                        text="Add Metrics"/>
                }/>
            <UpsertHealthScore
                handleModalConfig={handleModalConfig}
                modalConfig={modalConfig}
                getHealthScores={getHealthScores}/>
        </>
    );
};

export default CalculatedMetrics;
